// src/v3/currency/yuan.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var CurrencyYuanIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "CurrencyYuanIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M17.25 14.383h-4.5v-1.48h4.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-4.5v-.97l4.71-5.44c.27-.31.24-.79-.08-1.06a.748.748 0 0 0-1.06.08l-4.33 4.99-4.32-4.99a.745.745 0 0 0-1.05-.08c-.31.27-.35.74-.08 1.06l4.71 5.44v.97h-4.5c-.41 0-.75.34-.75.75s.34.75.75.75h4.5v1.48h-4.5c-.41 0-.75.34-.75.75s.34.75.75.75h4.5v3.62c0 .41.34.75.75.75s.75-.34.75-.75v-3.62h4.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Z"
  }
) });

export {
  CurrencyYuanIcon
};
